/**
 * Which chat the running turns belong to.
 *
 * "New chat" clears the memory the next turn is read against, but a turn already in flight keeps
 * writing after it: an execute opens the record it created before it stamps it, and the panel
 * stops showing a loader the moment the request itself resolves — so the producer can start over
 * while the turn is still finishing. Left unguarded, those writes land in the fresh chat, and its
 * first message goes out with the previous chat's event type, collected fields and created
 * record: the agent answers it as a continuation of a conversation that is no longer on screen.
 *
 * Every turn takes the session it began in and writes nothing once that session was left.
 */
let openSession = 0;

/** Called by the panel's reset — every turn still running belongs to the chat that was left. */
export function startAgentChatSession(): void {
    openSession += 1;
}

export function getAgentChatSession(): number {
    return openSession;
}

export function isAgentChatSessionOpen(session: number): boolean {
    return session === openSession;
}
